import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface InfoBoxProps {
  message: string;
  backgroundColor?: string;
  sx?: SxProps<Theme>;
}

const InfoBox: React.FC<InfoBoxProps> = ({ message, backgroundColor = '#FEF5DE', sx }) => {
  return (
    <Box
      sx={{
        backgroundColor,
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '16px',
        color: 'black',
        width: '100%',
        maxWidth: '750px',
        minWidth: '100px',
        boxSizing: 'border-box',
        ...sx
      }}
    >
      {message}
    </Box>
  );
};

export default InfoBox;
